import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LogoutAPISuccessResponseType } from "./types";




const useLogout = () => {
  const [isSessionExpired, setSessionExpiryStatus] = useState<boolean>(false)

  const { destroySession } = useContext(AuthContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const logoutBroadcaster = useMemo(() => new BroadcastChannel("user_logout"), []);




  const { mutate: onLogoutUser, error: logooutError, data: logoutResponse, removeErrorAndData } =
    useFetch<LogoutAPISuccessResponseType>(APIEndpoints.USER_LOGOUT);

  useEffect(() => {
    if (logoutResponse || logooutError) {
      hideLoader();
      if (logoutResponse && logoutResponse.status === 200) {
        setSessionExpiryStatus(false)
        destroySession();
        logoutBroadcaster.postMessage("user_logout");
        if (!isSessionExpired)
          showToast([logoutResponse.message], ToastTypes.SUCCESS);
        navigate('/users/sign_in');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutResponse, logooutError]);

  const logoutUser = (isSessionExpired: boolean = false) => {
    if ((logooutError && logooutError.length > 0) || logoutResponse)
      removeErrorAndData();

    setSessionExpiryStatus(isSessionExpired)
    setLoader();
    onLogoutUser();
  };




  useEffect(() => {
    logoutBroadcaster.onmessage = (bdChannel: { data: string; }) => {
      if (bdChannel.data === "user_logout") {
        window.document.addEventListener("visibilitychange", () => {
          if (!window.document.hidden)
            window.location.reload();

        });
      }
    };
  }, [logoutBroadcaster]);

  return { logoutUser };
}

export default useLogout;
